// extracted by mini-css-extract-plugin
export var boxItems = "_7u-1";
export var boxItemsLg = "_7u-2";
export var button = "_7u-7";
export var buttonHoverless = "_7u-9";
export var buttonLg = "_7u-8";
export var filterGroupBox = "_7u-0";
export var icon = "_7u-3";
export var iconSecondary = "_7u-6";
export var iconWrapper = "_7u-4";
export var iconWrapperLg = "_7u-5";
export var truncatedLabel = "_7u-a";